import type { FC } from 'react';
import { type ColorlessIconProps, Image } from '@direct-frontend/components';
import { ozonLogisticsSrc } from '../../../assets/ozonLogistics';
import { OZON_SERVICE_NAME } from '../../../lib/brand';

export const IconOzonLogistics: FC<ColorlessIconProps> = ({ size = 24 }) => (
    <Image alt={`${OZON_SERVICE_NAME} Доставка`} height={size} width={size} src={ozonLogisticsSrc} />
);
